export const PRD_ICON_VERSION = "2";
export const UAT_ICON_VERSION = "44";
export const DEV_ICON_VERSION = "46";
